// Admin gate built on top of requireSupabaseAuth. Verifies the authenticated
// user has `is_test_user = true` on their profile (the project's admin flag).
import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "./auth-middleware";

export const requireAdminAuth = createMiddleware({ type: "function" })
  .middleware([requireSupabaseAuth])
  .server(async ({ next, context }) => {
    const { supabaseAdmin } = await import("./client.server");
    const { data, error } = await supabaseAdmin
      .from("profiles")
      .select("is_test_user")
      .eq("id", context.userId)
      .maybeSingle();
    if (error) throw new Error("Forbidden");
    if (!data?.is_test_user) throw new Error("Forbidden: admin only");
    return next();
  });
